import React from "react"

import { ColorSwatch } from "packages/ui-shared/components/ColorSwatch"

import { productColorSwatch } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

type Props = {
  onClick?: () => void
  product: Pick<ProductCardDataType, "swatchImages">
}

export const ProductCardColorSwatch: React.FC<Props> = ({
  onClick,
  product,
}) => {
  if (!product.swatchImages?.length) return null

  const Swatch = (
    <div className={productColorSwatch}>
      <ColorSwatch visibleItemCount={4} items={product.swatchImages} />
    </div>
  )

  if (!onClick) return Swatch

  return (
    <button
      type="button"
      onClick={(event) => {
        event.preventDefault()
        onClick?.()
      }}
    >
      {Swatch}
    </button>
  )
}
